import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, Table, Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Badge, Label } from "reactstrap";
import { api } from '../../../../api';
import Cookies from 'js-cookie';
import * as XLSX from 'xlsx';

const Resource1 = () => {
    const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const [entriesToShow, setEntriesToShow] = useState(5);
    const [material, setMaterial] = useState([]);
    const [resourceList, setResourceList] = useState([]);
    const [dynamo, setDynamo] = useState([]);
    const [change, setChange] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [modalEmployee, setModalEmployee] = useState(null);
    
    const emp_id = Cookies.get('token');
    
    const [project, setProject] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const company_id = Cookies.get('company_id');
                if (!company_id || !emp_id) {
                  throw new Error('Missing company_id or emp_id in cookies');
                }
                const response = await api.get(`viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`);
                setProject(response.data);
                console.log(response.data);
                const response2 = await api.get(`requestresourse.php?g_m_id=${emp_id}&company_id=${company_id}`);
                setMaterial(response2.data);
                setDynamo(response2.data);
                setResourceList(response2.data);
                setChange(response2.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [emp_id]);

    const statusOptions = [
        { value: "Approved", label: "Accept" },
        { value: "Rejected", label: "Reject" }
    ];

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedproject, setselectedproject] = useState();
    const [modal, setModal] = useState(false);

    const toggleModalView = () => {
        setModalOpen(!modalOpen);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const [report, setreport] = useState({
        gm_id : emp_id,
        r_id : '',
        status : '',
        report : ''
    });

    const [formErrors, setFormErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setreport((prevState) => ({
        ...prevState,
        [name]: value,
        }));

        // Clear error for this field when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: null
            }));
        }

        console.log(report)
    };

    const handleItemClick = (id) => {
        setreport((prevState) => ({
          ...prevState,
          r_id : id,
        }));
        // Clear any previous errors when opening modal
        setFormErrors({});
        toggleModal();
    };

    const handleProjectSelection = async (p_id, p_name) => {
        setselectedproject(p_name);
        const company_id = Cookies.get('company_id');
        try {
            if(p_id === "all"){
                const response = await api.get(`requestresourse.php?g_m_id=${emp_id}&company_id=${company_id}`);
                console.log('API Response:', response.data);
                setMaterial(response.data);
                setChange(response.data);
                setCurrentPage(1);
            }else{
                const response = await api.get(`requestresourse.php?p_id=${p_id}&company_id=${company_id}`);
                console.log('API Response:', response.data);
                setMaterial(response.data);
                setChange(response.data);
                setCurrentPage(1);
            }  
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleStatusAction = async (e) => {
        e.preventDefault();

        // Clear previous errors
        setFormErrors({});

        // Validation: Check if all required fields are filled
        const errors = {};
        
        if (!report.status) errors.status = "Status selection is required";
        if (!report.report) errors.report = "Description is required";

        // Additional validation for description
        if (report.report && report.report.trim() === "") {
            errors.report = "Please provide a description";
        }

        // If there are errors, display them and return
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            alert("Please fill all required fields before submitting.");
            return;
        }

        try {
            const company_id = Cookies.get('company_id');
            const response = await api.post(`resourceAction.php`, { ...report, company_id });
            console.log(response.data);
            alert("Status action submitted successfully!");
            toggleModal(); // Close modal after successful submission
            // Reset form
            setreport({
                gm_id: emp_id,
                r_id: '',
                status: '',
                report: ''
            });
        } catch (error) {
            console.error('Error updating status:', error);
            alert("Error submitting status action. Please try again.");
        }
    };

    const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);
    const totalPages = Math.ceil(dynamo.length / entriesToShow);

    const toggleProjectDropdown1 = () => {
        setProjectDropdownOpen1(!projectDropdownOpen1);
    };

    const handleEntriesChange = (value) => {
        setEntriesToShow(value === 'All' ? resourceList.length : Number(value));
    };

    const prePage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const getSerialNumber = (index) => {
        return (currentPage - 1) * entriesToShow + index + 1;
    };

    useEffect(() => {
        if (Array.isArray(change)) {
            setMaterial(change.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow));
        } else {
            setMaterial([]);
        }
    }, [entriesToShow, currentPage, change]);
    
    useEffect(() => {
        if (Array.isArray(change)) {
            if (searchQuery.trim() === "") {
                setMaterial(change.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow));
            } else {
                const filteredDataDetails = change.filter(item => {
                    const role = item.role ? item.role.toLowerCase() : "";
                    const quantity = item.quantity ? String(item.quantity).toLowerCase() : "";
                    const description = item.description ? item.description.replace(/<\/?[^>]+(>|$)/g, '').toLowerCase() : "";
                    const status = item.status ? item.status.toLowerCase() : "";
                    const hr_status = item.hr_status ? item.hr_status.toLowerCase() : "";
                    const search = searchQuery.toLowerCase();
                    return (
                        role.includes(search) ||
                        quantity.includes(search) ||
                        description.includes(search) ||
                        status.includes(search) ||
                        hr_status.includes(search)
                    );
                });
                setMaterial(filteredDataDetails.slice(0, entriesToShow));
            }
        } else {
            setMaterial([]);
        }
    }, [searchQuery, entriesToShow, currentPage, change]);
    
    function removePTags(description) {
        return description.replace(/<\/?p>/g, '');
    }

    const handleDownload = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const fileName = 'Resourse_list';
    
        const columnMapping = {
            'role': 'Resource Type',
            'quantity': 'Quantity',
            'status' : 'Status'
        };
    
        const filteredMaterial = material.map(item => {
            let filteredItem = {};
            Object.keys(columnMapping).forEach(originalColumn => {
                if (item[originalColumn] !== undefined) {
                    filteredItem[columnMapping[originalColumn]] = item[originalColumn];
                }
            });
            return filteredItem;
        });
    
        const ws = XLSX.utils.json_to_sheet(filteredMaterial);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    
        const headerCellStyle = { font: { bold: true }, fill: { bgColor: { indexed: 64 } } };
        Object.keys(ws).filter(key => key.startsWith('A1')).forEach(key => ws[key].s = headerCellStyle);
    
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelData = new Blob([excelBuffer], { type: fileType });
        const excelUrl = URL.createObjectURL(excelData);
        const link = document.createElement('a');
        link.href = excelUrl;
        link.download = fileName + fileExtension;
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(excelUrl);
        }, 100);
    };

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container fluid>
                    <Row className=''>
                        <Col>
                            <Dropdown isOpen={projectDropdownOpen} toggle={() => setProjectDropdownOpen(!projectDropdownOpen)}>
                                <DropdownToggle caret>
                                {selectedproject ? selectedproject : "All Projects"}
                                </DropdownToggle>
                                <DropdownMenu left>
                                <DropdownItem onClick={() => handleProjectSelection("all", "All Projects")}>
                                    All Projects
                                </DropdownItem>
                                {Array.isArray(project) ? (
                                    project.map(project => (
                                        <DropdownItem key={project.p_name} onClick={() => handleProjectSelection(project.p_id, project.p_name)}>
                                            {project.p_name}
                                        </DropdownItem>
                                    ))
                                ) : (
                                    <DropdownItem >
                                            No Projects Found
                                    </DropdownItem>
                                )}
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                        
                        <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
                            <h1>Resource Details</h1>
                        </Col>
                        <Col className="order-xl-2 mb-5 mb-xl-0 d-flex ">
                            <Form className="navbar-search  form-inline ml-5 d-none d-md-flex ml-lg-auto ">
                                <FormGroup className="mb-0 ml-6">
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="fas fa-search" style={{color: 'black'}}/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Search Resource Type"
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                    <div style={{height:'68px', overflow: 'hidden'}}>
                        <img src={require("../../../images/cab (2).gif")} style={{ height: '80px' ,marginBottom:'-17px' }} alt="Delivery Truck" />
                        <span>Resource Delivery</span>
                    </div>
                    <Row className="">
                        <Col className="mb-5 mb-xl-0" xl="12">
                            <Card className="shadow" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">Resource List</h3>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <div className="mr-3">
                                                <Dropdown isOpen={projectDropdownOpen1} toggle={toggleProjectDropdown1}>
                                                    <DropdownToggle caret>
                                                        Show Entries: {entriesToShow === dynamo.length ? "All" : entriesToShow}
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                                        <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                                        <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </div>
                                            <button className="btn btn-success mr-2" style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} onClick={handleDownload}>Download</button>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">SL.No</th>
                                            <th scope="col">Resource Type</th>
                                            <th scope="col">Quantity</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {material && material.length > 0 ? (
                                    material.map((material, index) => (
                                        <tr key={index}>
                                            <th scope="row">{getSerialNumber(index)}</th>
                                        <td>{material.role}</td>
                                        <td>{material.quantity}</td>
                                        <td dangerouslySetInnerHTML={{ __html: removePTags(material.description) }}></td>
                                        <td>
                                        {
                                            material.status === "pending" ? (
                                                <Badge color='warning' >{material.status}</Badge>
                                            ) : material.status === "Rejected" ? (
                                                <Badge color='danger' >{material.status}</Badge>
                                            ) : (
                                                <Badge color='success'>{material.status}</Badge>
                                            )
                                        }
                                        </td>
                                        <td>
                                            <button className='btn btn-success' style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} onClick={() => { setModalEmployee(material); toggleModalView(); }}><i className="fa-solid fa-eye" style={{fontSize:'22px'}} ></i></button>
                                            <button className='btn btn-success' style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} onClick={() => handleItemClick(material.r_id) }>Set Action</button>
                                        </td>
                                        </tr>
                                    ))
                                    ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>No details available, Project not yet started</td>
                                    </tr>
                                    )}
                                    </tbody>
                                </Table>
                                <nav className='mt-3'>
                                    <ul className='pagination justify-content-center'>
                                        <li className='page-item'>
                                            <button
                                                className='page-link text-primary'
                                                onClick={prePage}
                                                disabled={currentPage === 1}
                                                style={{ border: 'none', background: 'none' }}
                                            >
                                                Prev
                                            </button>
                                        </li>
                                        <li className='page-item'>
                                            <button
                                                className='page-link text-primary'
                                                onClick={nextPage}
                                                disabled={currentPage === totalPages}
                                                style={{ border: 'none', background: 'none' }}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}><h2 style={{fontWeight:'bolder'}}>Status Action</h2></ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleStatusAction} >
                        <FormGroup>
                            <Label for="exampleSelect">Select</Label>
                            <Input
                                className={`form-control-alternative ${formErrors.status ? 'is-invalid' : ''}`}
                                id="input-status"
                                type="select"
                                name="status"
                                onChange={handleInputChange}
                                required
                            >
                                <option style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} value="">Select Status</option>
                                {statusOptions.map((option) => (
                                <option  key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                                ))}
                            </Input>
                            {formErrors.status && (
                                <div className="invalid-feedback d-block">
                                    {formErrors.status}
                                </div>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="exampleText">Description</Label>
                            <Input 
                                type="textarea" 
                                name="report" 
                                id="exampleText" 
                                className={`form-control-alternative ${formErrors.report ? 'is-invalid' : ''}`}
                                onChange={handleInputChange}
                                required
                            />
                            {formErrors.report && (
                                <div className="invalid-feedback d-block">
                                    {formErrors.report}
                                </div>
                            )}
                        </FormGroup>
                        <Row>
                            <Col lg='12' style={{ textAlign: 'center' }}>
                                <Button style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} type="submit">Submit</Button>
                            </Col>
                            </Row>
                    </Form>
                </ModalBody>
            </Modal>

            {modalEmployee && (
              <Modal isOpen={modalOpen} toggle={toggleModalView}>
                <ModalHeader toggle={toggleModalView}>Resource View</ModalHeader>
                <ModalBody >
                <div className="row">
                                    <div className="col-md-12">
                                        <div className=''>
                                            <label className='border p-2 rounded font-weight-bold' style={{width:'155px'}}>Material Type</label>
                                            <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                                            <label className='border p-2 rounded '>{modalEmployee.role}</label>
                                        </div>
                                        <div>
                                            <label className='border p-2 rounded font-weight-bold 'style={{width:'155px'}}>Quantity</label>
                                            <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                                            <label className='border p-2 rounded '>{modalEmployee.quantity}</label>
                                        </div><div>
                                            <label className='border p-2 rounded font-weight-bold 'style={{width:'155px'}}>Description</label>
                                            <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                                            <label className='border p-2 rounded '>{modalEmployee.description.replace(/<\/?[^>]+(>|$)/g, '')}</label>
                                        </div><div>
                                            <label className='border p-2 rounded font-weight-bold 'style={{width:'155px'}}>General Manager</label>
                                            <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                                            <label className='border p-2 rounded '>{modalEmployee.status}</label>
                                        </div><div>
                                            <label className='border p-2 rounded font-weight-bold 'style={{width:'155px'}}>HR</label>
                                            <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                                            <label className='border p-2 rounded '>{modalEmployee.hr_status}</label>
                                        </div><div>
                                            <label className='border p-2 rounded font-weight-bold 'style={{width:'155px'}}>HR Action</label>
                                            <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                                            <label className='border p-2 rounded '>{modalEmployee.hr_report}</label>
                                        </div>
                                    </div>
                </div>
                </ModalBody>
              </Modal>
            )}
        </>
    );
};
export default Resource1;
